import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getAnalytics } from "firebase/analytics";
import { GoogleAuthProvider } from "firebase/auth";
import { getDatabase } from "firebase/database";

const firebaseConfig = {
  apiKey: "AIzaSyAOoZ0fByz32ykUbqByAAHv1YK-0u9G3_0",
  authDomain: "texthere-431ce.firebaseapp.com",
  databaseURL: "https://texthere-431ce-default-rtdb.firebaseio.com",
  projectId: "texthere-431ce",
  storageBucket: "texthere-431ce.appspot.com",
  messagingSenderId: "11623120280",
  appId: "1:11623120280:web:82ede5e2ee75f1a0d37fed",
  measurementId: "G-TGM6M0PMJV",
};
export const firebase = initializeApp(firebaseConfig);
export const firebaseAuth = getAuth(firebase);
export const analytics = getAnalytics(firebase);
export const GoogleAuth = new GoogleAuthProvider();
export const RealDB = getDatabase(firebase);
export default firebase;
